import React from 'react'
import View from './view.js'
import { useDataChange } from 'Simple/Data.js'

export default function Logic(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'billing_center_search',
  })
  return <View {...props} onChangeFilter={change} />
}
